var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ManagingSection',[_c('ManagingBox',[_c('CheckboxList',{attrs:{"value":_vm.causeIds,"verticalUl":true,"checkboxList":_vm.causeList},on:{"input":_vm.causeIdsInput}})],1)],1),_c('div',{staticClass:"btn-wrap-main"},[_c('button',{staticClass:"btn-main orange",attrs:{"type":"button"},on:{"click":_vm.blindBatch}},[_vm._v(" 블라인드 처리 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }